var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRowBelow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C20 3.45 19.8042 2.97917 19.4125 2.5875C19.0208 2.19583 18.55 2 18 2L4 2C3.45 2 2.97917 2.19583 2.5875 2.5875C2.19583 2.97917 2 3.45 2 4L2 8C2 8.55 2.19583 9.02083 2.5875 9.4125C2.97917 9.80417 3.45 10 4 10H18C18.55 10 19.0208 9.80417 19.4125 9.4125C19.8042 9.02083 20 8.55 20 8V4ZM4 8V4L18 4V8L4 8Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.1V18H14V20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V14C2 13.45 2.19583 12.9792 2.5875 12.5875C2.97917 12.1958 3.45 12 4 12L18 12C18.55 12 19.0208 12.1958 19.4125 12.5875C19.8042 12.9792 20 13.45 20 14L4 14V14.1Z",
    fill: "#3DDB69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20V22H18V20H16V18H18V16H20V18Z",
    fill: "#3DDB69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRowBelow);
export default __webpack_public_path__ + "static/media/add_row_below.1165c99ecd21a4cf313da67b3821d395.svg";
export { ForwardRef as ReactComponent };